/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');

const addProductFormSave = function (e) {
  if (!e.detail || e.detail === 1) {
    const $form = $('#addProductForm');
    const data = {
      pid: $form.find('#addproduct_variation').val(),
      periodicity: $form.find('#addproduct_refill').children('option:selected').data('periodicity'),
      interval: $form.find('#addproduct_refill').val(),
      quantity: $form.find('#addproduct_quantity').val()
    };

    const isPositiveInteger = /^[1-9]\d*$/.test(data.quantity); // eslint-disable-line
    if (!isPositiveInteger) {
      $('.quty-error').show();
      $('#addproduct_quantity').on('change', function () {
        const qty = $(this).val();
        if (qty && qty > 0) {
          $('.quty-error').hide();
        }
      });
      return;
    }

    Object.keys(data).forEach(function (key) {
      data[key] = sorHelpers.sorValidation.sanitizeString(data[key]);
    });

    $.sorSpinner().start();
    setTimeout(function () {
      $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: data
      })
        .done(function (res) {
          // eslint-disable-line
          $.sorSpinner().stop(); // eslint-disable-line
          if (res.success) {
            // eslint-disable-line
            window.location = SmartOrderRefillSettings.Urls.manageOrders; // eslint-disable-line
          } else {
            // eslint-disable-line
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR); // eslint-disable-line
          } // eslint-disable-line
        })
        .fail(function (err) {
          // eslint-disable-line
          $.sorSpinner().stop(); // eslint-disable-line
          if (err.responseJSON && err.responseJSON.redirectURL) {
            // eslint-disable-line
            window.location.href = err.responseJSON.redirectURL; // eslint-disable-line
          } else {
            // eslint-disable-line
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR); // eslint-disable-line
          } // eslint-disable-line
        }); // eslint-disable-line
    }, 1000);
  }
};

// Get custom intervals
$(document).on('change', '#addproduct_variation', function () {
  const selectedProductID = sorHelpers.sorValidation.sanitizeString($(this).children('option:selected').val());
  if (!$.sorSpinner().isExist()) {
    $.sorSpinner().start();
  }
  $.ajax({
    type: 'POST',
    url: SmartOrderRefillSettings.Urls.getIntervalOptions,
    data: {
      selectedProductID: selectedProductID
    }
  })
    .done(function (response) {
      // eslint-disable-line
      if (response.intervals.length) {
        // eslint-disable-line
        $('#addproduct_refill').children().remove(); // eslint-disable-line
        response.intervals.forEach(function (interval) {
          // eslint-disable-line
          $('#addproduct_refill').append(
            `<option class="select-option" data-periodicity="${interval.periodicity}" value="${interval.value}">${interval.label}</option>`
          ); // eslint-disable-line
        }); // eslint-disable-line
      } else {
        // eslint-disable-line
        sorHelpers.sorModal.closeModal(); // eslint-disable-line
        sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, true); // eslint-disable-line
      } // eslint-disable-line
      $.sorSpinner().stop(); // eslint-disable-line
    })
    .fail(function () {
      // eslint-disable-line
      $.sorSpinner().stop(); // eslint-disable-line
      sorHelpers.sorModal.closeModal(); // eslint-disable-line
      sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, true); // eslint-disable-line
    }); // eslint-disable-line
});

// Get variants
$(document).on('change', '#addproduct_product', function () {
  const selectedProductID = sorHelpers.sorValidation.sanitizeString($(this).children('option:selected').val());
  const subscriptionID = sorHelpers.sorValidation.sanitizeString($(this).data('sid'));
  if (!$.sorSpinner().isExist()) {
    $.sorSpinner().start();
  }
  $.ajax({
    type: 'POST',
    url: SmartOrderRefillSettings.Urls.getVariantOptions,
    data: {
      selectedProductID: selectedProductID,
      subscriptionID: subscriptionID
    }
  })
    .done(function (response) {
      // eslint-disable-line
      if (response.variants.length) {
        // eslint-disable-line
        $('#addproduct_variation').children().remove(); // eslint-disable-line
        response.variants.forEach(function (variant) {
          // eslint-disable-line
          $('#addproduct_variation').append(`<option class="select-option" value="${variant.value}">${variant.label}</option>`); // eslint-disable-line
        }); // eslint-disable-line
        $('#addproduct_variation').trigger('change'); // eslint-disable-line
      } else {
        // eslint-disable-line
        $.sorSpinner().stop(); // eslint-disable-line
        sorHelpers.sorModal.closeModal(); // eslint-disable-line
        sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, true); // eslint-disable-line
      } // eslint-disable-line
    })
    .fail(function () {
      // eslint-disable-line
      $.sorSpinner().stop(); // eslint-disable-line
      sorHelpers.sorModal.closeModal(); // eslint-disable-line
      sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, true); // eslint-disable-line
    }); // eslint-disable-line
});

const addProductOptions = {
  autoOpen: true,
  bgiframe: true,
  title: typeof SmartOrderRefillSettings !== 'undefined' ? SmartOrderRefillSettings.Resources.SOR_ADD_PRODUCT_TITLE : '',
  modal: true,
  emptyOnClose: false,
  buttons: {
    SOR_GLOBAL_CLOSE: sorHelpers.sorModal.closeModal,
    SOR_GLOBAL_SAVE: addProductFormSave
  }
};

const initAddProductForm = function () {
  $(document)
    .off('click', '.addproduct')
    .on('click', '.addproduct', function (e) {
      // eslint-disable-line
      if (!e.detail || e.detail === 1) {
        // eslint-disable-line
        e.preventDefault(); // eslint-disable-line
        $.sorSpinner().start(); // eslint-disable-line
        var url = $(this).attr('data-link'); // eslint-disable-line
        var $container = sorHelpers.sorModal.createContainer('#addproduct'); // eslint-disable-line
        $container.load(url, function () {
          // eslint-disable-line
          if ($(this).find('#addproduct_product').length > 0) {
            // eslint-disable-line
            sorHelpers.sorModal.createModal($container, addProductOptions); // eslint-disable-line
            $('#addproduct_product').trigger('change'); // eslint-disable-line
          } else {
            // eslint-disable-line
            sorHelpers.sorModal.initWarningModal(SmartOrderRefillSettings.Resources.SOR_ADD_PRODUCT_WARNING); // eslint-disable-line
            $.sorSpinner().stop(); // eslint-disable-line
          } // eslint-disable-line
        }); // eslint-disable-line
      } // eslint-disable-line
    }); // eslint-disable-line
};

module.exports = {
  initAddProductForm: initAddProductForm
};
